import React, { useState } from 'react';
import { FaChevronUp } from 'react-icons/fa';
import './scroll-to-top-styles.css';

const ScrollToTop = () => {
	const [ showArrow, setShowArrow ] = useState(false);

	window.document.body.onscroll = () => {
		if (window.pageYOffset > 1200) {
			setShowArrow((prev) => (prev = true));
		} else {
			setShowArrow((prev) => (prev = false));
		}
	};

	const handleScrollToTop = () => {
		setShowArrow(false);
		console.log(showArrow);
		return window.scrollTo(0, 0);
	};

	return (
		<React.Fragment>
			{showArrow ? (
				<div className="scroll-to-top-container" onClick={handleScrollToTop}>
					<FaChevronUp className="scroll-to-top-arrow" />
				</div>
			) : null}
		</React.Fragment>
	);
};

export default ScrollToTop;
